// Missionary Jobs listing — client-side search + taxonomy filtering via Fuse.js.
// Ported from the archive-video pattern. Data is printed inline in
// missionary-jobs.php as window.missionaryJobsData. renderCard() must stay in
// sync with imb_render_job_listing_card() in that template.
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Fuse === 'undefined') {
        console.warn('Fuse is not loaded.');
        return;
    }

    if (!window.missionaryJobsData) {
        console.warn('Missionary jobs data is not available.');
        return;
    }

    var resultsGrid = document.querySelector('.js-jobs-results');
    var searchInput = document.querySelector('#jobs-search');
    var loadMoreWrap = document.querySelector('.js-jobs-load-more-wrap');
    var loadMoreButton = document.querySelector('.js-jobs-load-more');
    var filterButtons = document.querySelectorAll('.jobs-filters__button');
    var filterToggle = document.querySelector('.js-jobs-filter-toggle');
    var filterPanel = document.querySelector('.js-jobs-filter-panel');
    var filterClear = document.querySelector('.js-jobs-filter-clear');
    var filterCountBadge = document.querySelector('.js-jobs-filter-count');
    var countShown = document.querySelector('.js-jobs-count-shown');
    var countTotal = document.querySelector('.js-jobs-count-total');

    if (!resultsGrid) {
        return;
    }

    var initialCount = window.missionaryJobsInitialCount
        || resultsGrid.querySelectorAll('.job-card').length
        || 9;
    var visibleCount = resultsGrid.querySelectorAll('.job-card').length || initialCount;
    var currentResults = window.missionaryJobsData;

    // Filter state is mirrored in the query string so a filtered view can be
    // shared, bookmarked and reloaded. PHP has already applied whatever was in
    // the URL to the markup we're looking at, and hands the parsed state over
    // here — see $jobs_filter_query_vars in 2024/missionary-jobs.php.
    var queryVars = window.missionaryJobsQueryVars || {};
    var searchVar = window.missionaryJobsSearchVar || 'q';

    var currentSearchValue = window.missionaryJobsActiveSearch || '';
    var selectedFilters = {};

    (function adoptServerState() {
        var fromServer = window.missionaryJobsActiveFilters;
        if (!fromServer) {
            return;
        }
        Object.keys(fromServer).forEach(function (taxonomy) {
            var terms = fromServer[taxonomy];
            if (terms && terms.length) {
                selectedFilters[taxonomy] = terms.slice();
            }
        });
    }());

    // Rebuild the query string from the current state. Only filters appear —
    // any unrelated params already on the URL are preserved.
    function writeStateToUrl() {
        if (!window.history || !window.history.replaceState) {
            return;
        }

        var params = new URLSearchParams(window.location.search);

        Object.keys(queryVars).forEach(function (taxonomy) {
            var name = queryVars[taxonomy];
            var terms = selectedFilters[taxonomy];

            if (terms && terms.length) {
                params.set(name, terms.join(','));
            } else {
                params.delete(name);
            }
        });

        if (currentSearchValue.trim()) {
            params.set(searchVar, currentSearchValue.trim());
        } else {
            params.delete(searchVar);
        }

        var qs = params.toString();
        var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;

        // replaceState, not pushState: a facet toggle is a refinement, not a
        // navigation. pushState here would make Back step through every single
        // chip click before leaving the page.
        try {
            window.history.replaceState(null, '', url);
        } catch (e) {
            // Safari throttles the history API (~100 calls / 30s) and throws once
            // over. Losing a URL update is not worth breaking the filtering.
        }
    }

    // Search fires on every keystroke; debounce the URL write so fast typing
    // can't trip that throttle. Filtering itself stays immediate.
    var urlWriteTimer = null;
    function scheduleUrlWrite() {
        if (urlWriteTimer) {
            clearTimeout(urlWriteTimer);
        }
        urlWriteTimer = setTimeout(function () {
            urlWriteTimer = null;
            writeStateToUrl();
        }, 300);
    }

    // Re-read the URL into state — used for Back/Forward, since replaceState
    // entries still restore a different query string on history navigation.
    function readStateFromUrl() {
        var params = new URLSearchParams(window.location.search);
        var next = {};

        Object.keys(queryVars).forEach(function (taxonomy) {
            var raw = params.get(queryVars[taxonomy]);
            if (!raw) {
                return;
            }
            var terms = raw.split(',').map(function (t) {
                return t.trim();
            }).filter(Boolean);

            // Only accept slugs that correspond to a real chip on the page.
            var known = terms.filter(function (term) {
                return !!document.querySelector(
                    '.jobs-filters__button[data-taxonomy="' + taxonomy + '"][data-term="' + term + '"]'
                );
            });

            if (known.length) {
                next[taxonomy] = known;
            }
        });

        selectedFilters = next;
        currentSearchValue = params.get(searchVar) || '';

        if (searchInput) {
            searchInput.value = currentSearchValue;
        }
    }

    var fuse = new Fuse(window.missionaryJobsData, {
        keys: ['title', 'excerpt', 'searchText'],
        threshold: 0.35,
        includeScore: true
    });

    function escapeHtml(value) {
        if (!value) {
            return '';
        }

        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function getSearchResults(searchValue) {
        var searchTerm = searchValue.trim();

        if (!searchTerm) {
            return window.missionaryJobsData;
        }

        return fuse.search(searchTerm).map(function (result) {
            return result.item;
        });
    }

    function jobMatchesSelectedFilters(job) {
        var selectedTaxonomies = Object.keys(selectedFilters);

        if (!selectedTaxonomies.length) {
            return true;
        }

        // AND across taxonomies, OR within a single taxonomy.
        return selectedTaxonomies.every(function (taxonomy) {
            var selectedTerms = selectedFilters[taxonomy];

            if (!selectedTerms || !selectedTerms.length) {
                return true;
            }

            if (!job.taxonomies || !job.taxonomies[taxonomy]) {
                return false;
            }

            var jobTermSlugs = job.taxonomies[taxonomy].map(function (term) {
                return term.slug;
            });

            return selectedTerms.some(function (selectedTerm) {
                return jobTermSlugs.indexOf(selectedTerm) !== -1;
            });
        });
    }

    function getFilteredResults(searchValue) {
        return getSearchResults(searchValue).filter(jobMatchesSelectedFilters);
    }

    // Does the job match every selected facet EXCEPT the given one? Used to decide
    // which terms in that facet would still return results if selected.
    function matchesFiltersExcept(job, exceptTaxonomy) {
        return Object.keys(selectedFilters).every(function (taxonomy) {
            if (taxonomy === exceptTaxonomy) {
                return true;
            }
            var selectedTerms = selectedFilters[taxonomy];
            if (!selectedTerms || !selectedTerms.length) {
                return true;
            }
            if (!job.taxonomies || !job.taxonomies[taxonomy]) {
                return false;
            }
            var slugs = job.taxonomies[taxonomy].map(function (t) { return t.slug; });
            return selectedTerms.some(function (s) { return slugs.indexOf(s) !== -1; });
        });
    }

    function jobHasTerm(job, taxonomy, term) {
        return !!(job.taxonomies && job.taxonomies[taxonomy] && job.taxonomies[taxonomy].some(function (t) {
            return t.slug === term;
        }));
    }

    // Disable any term that would yield 0 results given the current selections in
    // the OTHER facets (search included). Selected terms stay enabled so they can
    // be toggled off.
    function updateDisabledTerms() {
        var searchResults = getSearchResults(currentSearchValue);

        filterButtons.forEach(function (button) {
            var taxonomy = button.getAttribute('data-taxonomy');
            var term = button.getAttribute('data-term');
            if (!taxonomy || !term) {
                return;
            }

            var isSelected = !!(selectedFilters[taxonomy] && selectedFilters[taxonomy].indexOf(term) !== -1);
            var available = isSelected || searchResults.some(function (job) {
                return matchesFiltersExcept(job, taxonomy) && jobHasTerm(job, taxonomy, term);
            });

            button.classList.toggle('is-disabled', !available);
            button.disabled = !available;
        });
    }

    function renderCard(job) {
        var imageHtml = '<span class="job-card__media">' + (job.thumbnailUrl
            ? '<img class="job-card__image" src="' + escapeHtml(job.thumbnailUrl) + '" alt="" aria-hidden="true">'
            : '<span class="job-card__image job-card__image--placeholder" aria-hidden="true"></span>') + '</span>';

        var descriptionHtml = job.excerpt
            ? '<p class="job-card__description">' + escapeHtml(job.excerpt) + '</p>'
            : '';

        var metaHtml = '';
        if (job.metaRows && job.metaRows.length) {
            metaHtml = '<div class="job-card__meta">' + job.metaRows.map(function (row) {
                // row.icon is a trusted inline SVG string emitted by PHP.
                return '<div class="job-card__meta-row"><span class="job-card__meta-icon">' + row.icon + '</span><span class="job-card__meta-text">' + escapeHtml(row.text) + '</span></div>';
            }).join('') + '</div>';
        }

        var chipsHtml = '';
        if (job.chips && job.chips.length) {
            chipsHtml = '<div class="job-card__chips">' + job.chips.map(function (chip) {
                return '<span class="job-card__chip" style="background-color:' + escapeHtml(chip.background_color) + ';color:' + escapeHtml(chip.text_color) + ';">' + escapeHtml(chip.name) + '</span>';
            }).join('') + '</div>';
        }

        // Chips live INSIDE the footer (below the divider, above the CTA) per Figma.
        var ctaHtml = '<span class="job-card__cta">Learn More <svg width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.182832 9.81724C-0.060841 9.57357 -0.060841 9.17525 0.182832 8.93158L4.11436 5L0.182833 1.06842C-0.0608403 0.824748 -0.0608402 0.426429 0.182833 0.182756C0.426506 -0.0609174 0.820077 -0.0609173 1.06375 0.182756L5.44054 4.55954C5.68421 4.80322 5.68421 5.19679 5.44054 5.44046L1.06375 9.81724C0.820076 10.0609 0.426506 10.0609 0.182832 9.81724Z" fill="currentColor" /></svg></span>';
        var footerHtml = '<div class="job-card__footer">' + chipsHtml + ctaHtml + '</div>';

        return ''
            + '<a class="job-card" href="' + escapeHtml(job.permalink) + '">'
            + imageHtml
            + '<div class="job-card__content">'
            + '<h3 class="job-card__title">' + escapeHtml(job.title) + '</h3>'
            + descriptionHtml
            + metaHtml
            + footerHtml
            + '</div>'
            + '</a>';
    }

    function updateLoadMoreButton() {
        if (loadMoreWrap) {
            loadMoreWrap.style.display = (visibleCount >= currentResults.length) ? 'none' : '';
        }

        // Keep the "Showing X of Y" count in sync with whatever is rendered.
        if (countShown) {
            countShown.textContent = Math.min(visibleCount, currentResults.length);
        }
        if (countTotal) {
            countTotal.textContent = currentResults.length;
        }
    }

    function activeFilterCount() {
        return Object.keys(selectedFilters).reduce(function (sum, taxonomy) {
            return sum + (selectedFilters[taxonomy] ? selectedFilters[taxonomy].length : 0);
        }, 0);
    }

    function updateFilterBadge() {
        if (!filterCountBadge) {
            return;
        }

        var count = activeFilterCount();

        if (count > 0) {
            filterCountBadge.textContent = count;
            filterCountBadge.hidden = false;
        } else {
            filterCountBadge.hidden = true;
        }
    }

    function renderVisibleCards() {
        var visibleJobs = currentResults.slice(0, visibleCount);

        if (!visibleJobs.length) {
            resultsGrid.innerHTML = '<p class="jobs-listing__empty">No jobs found.</p>';
            updateLoadMoreButton();
            return;
        }

        resultsGrid.innerHTML = visibleJobs.map(renderCard).join('');
        updateLoadMoreButton();
    }

    function appendVisibleCards(startIndex, endIndex) {
        var newJobs = currentResults.slice(startIndex, endIndex);

        if (!newJobs.length) {
            updateLoadMoreButton();
            return;
        }

        resultsGrid.insertAdjacentHTML('beforeend', newJobs.map(renderCard).join(''));
        updateLoadMoreButton();
    }

    function updateResults() {
        currentResults = getFilteredResults(currentSearchValue);
        visibleCount = initialCount;
        renderVisibleCards();
        updateDisabledTerms();
    }

    function syncFilterButtons() {
        filterButtons.forEach(function (button) {
            var taxonomy = button.getAttribute('data-taxonomy');
            var term = button.getAttribute('data-term');

            if (!taxonomy || !term) {
                return;
            }

            var isActive = !!(selectedFilters[taxonomy] && selectedFilters[taxonomy].indexOf(term) !== -1);
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
    }

    function toggleSelectedFilter(taxonomy, term) {
        if (!selectedFilters[taxonomy]) {
            selectedFilters[taxonomy] = [];
        }

        var index = selectedFilters[taxonomy].indexOf(term);

        if (index === -1) {
            selectedFilters[taxonomy].push(term);
        } else {
            selectedFilters[taxonomy].splice(index, 1);
        }

        if (!selectedFilters[taxonomy].length) {
            delete selectedFilters[taxonomy];
        }
    }

    if (searchInput) {
        searchInput.addEventListener('input', function (event) {
            currentSearchValue = event.target.value;
            updateResults();
            scheduleUrlWrite();
        });
    }

    filterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var taxonomy = button.getAttribute('data-taxonomy');
            var term = button.getAttribute('data-term');

            if (!taxonomy || !term) {
                return;
            }

            toggleSelectedFilter(taxonomy, term);
            syncFilterButtons();
            updateFilterBadge();
            updateResults();
            writeStateToUrl();
        });
    });

    // Filter panel: toggle open/closed via the "Filter" button.
    if (filterToggle && filterPanel) {
        filterToggle.addEventListener('click', function () {
            var isOpen = filterPanel.classList.toggle('is-open');
            filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    }

    // "Clear all" resets every filter + the search.
    if (filterClear) {
        filterClear.addEventListener('click', function () {
            selectedFilters = {};
            currentSearchValue = '';
            if (searchInput) {
                searchInput.value = '';
            }
            syncFilterButtons();
            updateFilterBadge();
            updateResults();
            writeStateToUrl();
        });
    }

    // Back/Forward across differing query strings — re-read and re-render.
    window.addEventListener('popstate', function () {
        readStateFromUrl();
        syncFilterButtons();
        updateFilterBadge();
        updateResults();
    });

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
            var previousVisibleCount = visibleCount;

            visibleCount += initialCount;
            appendVisibleCards(previousVisibleCount, visibleCount);
        });
    }

    // Bring currentResults in line with the state the server rendered, otherwise
    // "Showing X of Y" and the View more button would describe the unfiltered set
    // until the next interaction.
    currentResults = getFilteredResults(currentSearchValue);

    // The server applies taxonomy filters but not free-text search (Fuse.js is
    // client-side only), so a ?q= link needs one render pass to narrow further.
    // Without a search term the server markup is already correct — leave it be
    // rather than repainting the grid for no visual change.
    if (currentSearchValue.trim()) {
        visibleCount = initialCount;
        renderVisibleCards();
    }

    syncFilterButtons();
    updateFilterBadge();
    updateLoadMoreButton();
    updateDisabledTerms();
});
